import React from "react";
import { StyledTokenomicDog } from "./styledComponents/Containers";

export default function TokenomicDog() {
  return <StyledTokenomicDog>
    <img className="tokenomic-dog" src="./dog-tokenomics.png"/>
  </StyledTokenomicDog>;
}
